export const STATUS_TYPES = {
	awaitingBids: 'awaiting_bids',
	counterPending: 'counter_pending',
	counterReceived: 'counter_received',
	counterSent: 'counter_sent',
	leader: 'leader',
	lost: 'lost',
	onOffer: 'on_offer',
	outbid: 'outbid',
	pendingBid: 'pending_bid',
	sold: 'sold',
	topBid: 'top_bid',
	won: 'won',
};

const EMPTY_STATUS_ROW = { primary: '', secondary: null };
export const DEFAULT_STATUS_LABELS = {
	type: STATUS_TYPES.awaitingBids,
	groupType: '',
	first_row: EMPTY_STATUS_ROW,
	second_row: EMPTY_STATUS_ROW,
	hero_image: null,
};
